module.exports = {
      id: "shield-check-usage",
      viewBox: "0 0 19 22",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#shield-check",
      toString: function () {
        return this.url;
      }
    }